export { FastBuyPriceCardFeature } from './fast-buy';
